export enum TraccarUtilityStatus {
  Opened = 'OPENED',
  Closed = 'CLOSED',
}
